import { decorate, observable } from 'mobx';
import { ParentStore } from '@mq/voltron-parent';

class KYCResultStore extends ParentStore {
  constructor(args: Object = {}) {
    super(args);
    this.load(args);
  }
  // values
  value: string = '';
  status: string = null;
}

decorate(KYCResultStore, {
  // values
  value: observable,
  status: observable,
});

export default KYCResultStore;
